import { render } from "./JMUpload.vue?vue&type=template&id=09812fa9&ts=true&lang=pug"
import script from "./JMUpload.vue?vue&type=script&lang=ts"
export * from "./JMUpload.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__